@if ($attributeValueLikeNode(); as attributeValueLikeNode) {
    <cm-geometry-attribute-value-like-node-inspector [node]="attributeValueLikeNode"></cm-geometry-attribute-value-like-node-inspector>
}
@if ($attributeLikeNode(); as attributeLikeNode) {
    <cm-geometry-attribute-like-node-inspector [node]="attributeLikeNode"></cm-geometry-attribute-like-node-inspector>
}
@if ($attributeSetLikeNode(); as attributeSetLikeNode) {
    <cm-geometry-attribute-set-like-node-inspector [node]="attributeSetLikeNode"></cm-geometry-attribute-set-like-node-inspector>
}
